import { FLOW_TEXT_INPUT_BASE } from "../../styles/twDesignPrimitives";

const MONEY_RANGE_INPUT_ERROR =
  "!border-rose-500 focus:!border-rose-500 focus:!ring-rose-200/90 focus-visible:!border-rose-500 focus-visible:!ring-rose-200/90";

type Props = {
  minLabel: string;
  maxLabel: string;
  minValue: string;
  maxValue: string;
  hasError: boolean;
  onMinChange: (value: string) => void;
  onMaxChange: (value: string) => void;
};

export function PropertiesListMoneyRangeFields({
  minLabel,
  maxLabel,
  minValue,
  maxValue,
  hasError,
  onMinChange,
  onMaxChange,
}: Props) {
  const inputClassName = `${FLOW_TEXT_INPUT_BASE} !font-[inherit]${
    hasError ? ` ${MONEY_RANGE_INPUT_ERROR}` : ""
  }`;

  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
      <label className="flex flex-col gap-1 text-left text-xs font-medium text-slate-600">
        {minLabel}
        <input
          className={inputClassName}
          inputMode="numeric"
          aria-invalid={hasError}
          value={minValue}
          onChange={(event) => onMinChange(event.target.value)}
          placeholder="0"
        />
      </label>
      <label className="flex flex-col gap-1 text-left text-xs font-medium text-slate-600">
        {maxLabel}
        <input
          className={inputClassName}
          inputMode="numeric"
          aria-invalid={hasError}
          value={maxValue}
          onChange={(event) => onMaxChange(event.target.value)}
          placeholder="0"
        />
      </label>
    </div>
  );
}
